// ====================================================================================
// navHandler.module
// ====================================================================================
import $ from "jquery";

const ICON_BUTTON_SELECTOR = "#navbar .icon-button";
const CLOSE_BUTTON_SELECTOR = "#navbar .dropdown-menu .close-button";

// Focus trap functionality
const getFocusableElements = (container) => {
  const focusableSelectors = [
    "a[href]",
    "button:not([disabled])",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    '[tabindex]:not([tabindex="-1"])',
  ];

  return container.find(focusableSelectors.join(", ")).filter(":visible");
};

const handleFocusTrap = (e) => {
  if (e.key !== "Tab") return;

  // Check for mobile navigation (.navbar-collapse)
  const $mobileNav = $(".navbar-collapse.in, .navbar-collapse.show").first();
  if ($mobileNav.length && $mobileNav.is(":visible")) {
    const $focusableElements = getFocusableElements($mobileNav);
    if ($focusableElements.length > 1) {
      trapFocus(e, $focusableElements, $mobileNav[0]);
    }
    return;
  }

  // Check for desktop dropdown menus
  const $openDropdown = $(".has-subpages.m-open .dropdown-menu")
    .filter(":visible")
    .first();
  if ($openDropdown.length) {
    const $focusableElements = getFocusableElements($openDropdown);
    if ($focusableElements.length > 1) {
      trapFocus(e, $focusableElements, $openDropdown[0]);
    }
  }
};

const trapFocus = (e, $focusableElements, container) => {
  const firstFocusable = $focusableElements.first()[0];
  const lastFocusable = $focusableElements.last()[0];
  const currentFocus = document.activeElement;

  // Check if focus is within the container and we have focusable elements
  if (!container.contains(currentFocus) || !firstFocusable || !lastFocusable)
    return;

  // Don't trap focus if there's only one focusable element
  if (firstFocusable === lastFocusable) return;

  if (e.shiftKey) {
    // Shift + Tab (backwards)
    if (currentFocus === firstFocusable) {
      e.preventDefault();
      lastFocusable.focus();
    }
  } else {
    // Tab (forwards)
    if (currentFocus === lastFocusable) {
      e.preventDefault();
      firstFocusable.focus();
    }
  }
};

// Behandelt Klick- und Tastaturereignisse (Enter/Space) für Icon-Buttons
const handleIconButton = (e) => {
  // Bei 'keyup' nur fortfahren, wenn Enter oder Leertaste gedrückt wurde
  if (e.type === "keyup" && !(e.key === "Enter" || e.key === " ")) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  let $iconButton = $(e.target).closest(".icon-button");
  let $listItem = $iconButton.closest(".has-subpages");
  if (!$listItem.length) return;

  let $menuToToggle = $listItem.children(".subMenu, .dropdown-menu").first();
  if (!$menuToToggle.length) return;

  if (!$listItem.hasClass("m-open")) {
    if ($listItem.hasClass("dropdown")) {
      $listItem
        .parents(".navbar-nav")
        .find(".dropdown.m-open")
        .not($listItem) // Das aktuelle Element ausschließen
        .each(function () {
          const $otherOpenListItem = $(this);
          const $otherIconButton = $otherOpenListItem.find(
            ".icon-button.is-open"
          );
          if ($otherIconButton.length) {
            $otherIconButton.trigger("mouseup");
          } else {
            $otherOpenListItem.removeClass("m-open");
            $otherOpenListItem
              .find(".icon-button")
              .removeClass("is-open")
              .attr("aria-expanded", "false");
            $otherOpenListItem
              .children(".subMenu, .dropdown-menu")
              .first()
              .slideUp();
          }
        });
    }

    $listItem.addClass("m-open");
    $iconButton.addClass("is-open").attr("aria-expanded", "true");
    $listItem.hasClass("dropdown")
      ? $menuToToggle.show()
      : $menuToToggle.slideDown();
  } else {
    $listItem.removeClass("m-open");
    $iconButton.removeClass("is-open").attr("aria-expanded", "false");
    $listItem.hasClass("dropdown")
      ? $menuToToggle.hide()
      : $menuToToggle.slideUp();
  }
};

// Behandelt das 'keyup'-Event auf dem Dokument für die Escape-Taste
const handleEscapeKeyForSubmenus = (e) => {
  if (e.key === "Escape") {
    let $target = $(e.target);
    let $openSubmenuParent = $target.closest(".has-subpages.m-open");

    if ($openSubmenuParent.length > 0) {
      // Es gibt ein offenes Untermenü, in dem sich der Fokus befindet oder das ein Vorfahre ist.
      const $iconButton = $openSubmenuParent
        .find(".icon-button.is-open")
        .first();
      if ($iconButton.length > 0) {
        $iconButton.trigger("mouseup"); // Schließt das Menü über den Handler des Icon-Buttons
        // Fokus auf den zugehörigen Icon-Button setzen
        const $iconButtonToFocus = $iconButton.siblings(".icon-button").first();
        if ($iconButtonToFocus.length) {
          $iconButtonToFocus.focus();
        } else {
          // Fallback, falls kein direkter Geschwister-Icon-Button vorhanden ist
          $openSubmenuParent.find(".icon-button").first().focus();
        }
      } else {
        // Fallback, wenn kein .is-open icon-button gefunden wird, aber .m-open gesetzt ist
        // Dies könnte passieren, wenn das Menü anders geöffnet wurde oder die Klassen inkonsistent sind.
        const $anyIconButton = $openSubmenuParent.find(".icon-button").first();
        if ($anyIconButton.length) {
          $anyIconButton.trigger("mouseup");
          const $iconButtonToFocus = $anyIconButton
            .siblings(".icon-button")
            .first();
          if ($iconButtonToFocus.length) {
            $iconButtonToFocus.focus();
          } else {
            $openSubmenuParent.find(".icon-button").first().focus();
          }
        } else {
          $openSubmenuParent
            .removeClass("m-open")
            .find(".subMenu, .dropdown-menu")
            .first()
            .slideUp();
          $openSubmenuParent.find("> .icon-button, > button").first().focus();
        }
      }
    }
  }
};

// Behandelt Klick-Events für Close-Buttons
const handleCloseButton = (e) => {
  // Bei 'keyup' nur fortfahren, wenn Enter gedrückt wurde
  if (e.type === "keyup" && e.key !== "Enter") {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  let $closeButton = $(e.target).closest(".close-button");
  let $dropdownMenu = $closeButton.closest(".dropdown-menu");
  let $listItem = $dropdownMenu.closest(".has-subpages");

  if (!$listItem.length) return;

  // Menü schließen
  $listItem.removeClass("m-open");
  let $iconButton = $listItem.find(".icon-button.is-open").first();
  if ($iconButton.length) {
    $iconButton.removeClass("is-open").attr("aria-expanded", "false");
  }

  // Animation basierend auf Dropdown-Typ
  if ($listItem.hasClass("dropdown")) {
    $dropdownMenu.hide();
  } else {
    $dropdownMenu.slideUp();
  }

  // Fokus auf den Icon-Button setzen für bessere Accessibility
  let $iconButtonToFocus = $listItem.find(".icon-button").first();
  if ($iconButtonToFocus.length) {
    $iconButtonToFocus.focus();
  }
};

export const init = () => {
  $(document).on(
    "mouseup touchend keyup",
    ICON_BUTTON_SELECTOR,
    handleIconButton
  );
  $(document).on(
    "mouseup touchend keyup",
    CLOSE_BUTTON_SELECTOR,
    handleCloseButton
  );
  $(document).on("keyup", handleEscapeKeyForSubmenus);
  $(document).on("keydown", handleFocusTrap);
};
